import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import sessionUtils from '../../../utilities/SessionHandler'
import Navbar from '../../../components/Private/Navbar'
import ListSection from '../../../components/Private/ListSection'
import ModalComponent from '../../../components/Private/ModalComponent'
import userService from '../../../services/users'
import ticketService from '../../../services/tickets'

export default function List() {

  const navigateTo = useNavigate()

  let credentials = sessionUtils.getParsedCredentials()

  const [isLoading, setIsLoading] = useState(true)

  const [user, setUser] = useState(null)

  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorModalTitle, setErrorModalTitle] = useState('Error')
  const [errorMessage, setErrorMessage] = useState('')

  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const [deleteModalTitle, setDeleteModalTitle] = useState('Borrar ticket')

  const [listData, setListData] = useState(null)

  const [selectedItemId, setSelectedItemId] = useState(null)

  const handleUserLoad = async () => {

    const result = await userService.get(credentials.id)
    setUser(result)
  }

  const handleDataDelete = async (itemId) => {
    await ticketService.remove(itemId)
    await handleDataLoad()
  }

  const handleDataLoad = async () => {
    const result = await ticketService.list()

    let finalResult = [];
    if ([3].includes(parseInt(credentials.role_id))) {
      let filteredResultNoUser = []
      let filteredResultThisUser = []

      filteredResultNoUser = result.filter(item => item.user_id === null)
      filteredResultThisUser = result.filter(item => item.user_id === credentials.id)

      finalResult = [
        ...filteredResultNoUser,
        ...filteredResultThisUser
      ]

    } else {
      finalResult = result
    }

    if (finalResult.length === 0) {
      setListData([])
      setIsLoading(false)
      return
    }

    finalResult = finalResult.filter(item => item.ticketStatus === 'en revisión')

    setListData(finalResult)
    setIsLoading(false)
  }

  useEffect(() => {
    handleUserLoad()
    handleDataLoad()
  }, [])

  return (
    <>
      <Navbar />
      {
        isLoading &&
        <>
          <div className='vh-100 d-flex justify-content-center align-items-center'>
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </>
      }
      {
        listData
        &&
        <>
          {
            !isLoading && <ListSection
              pagination={
                {
                  itemsPerPage: 5,
                  maxPagesInPagination: 5,
                  currentPage: 1,
                  prevPage: 'Anterior',
                  nextPage: 'Siguiente',
                  lastPage: 'Última',
                }
              }
              title={`Tickets`}
              hasSearch={true}
              hasYear={false}
              tabs={false}
              backRoute={
                {
                  title: 'Volver',
                  onClick: () => {
                    navigateTo('/')
                  }
                }
              }
              actions={false}
              columns={
                [
                  {
                    title: 'Nombre',
                    field: 'ticketTitle',
                    type: 'text',
                  },
                  {
                    title: 'Estado',
                    field: 'ticketStatus',
                    type: 'text',
                  },
                  {
                    title: 'Agente',
                    field: 'user_id',
                    type: 'text',
                  },
                  {
                    title: 'Acciones',
                    field: 'actions',
                    type: 'actions',
                  },
                ]
              }
              rows={
                [
                  ...listData.map((item, index) => {

                    let newActions = [];

                    if (item.ticketStatus === 'creado' || item.ticketStatus === 'borrador') {
                      newActions.push(
                        {
                          className: 'btn',
                          icon: 'bi bi-pencil',
                          tooltip: 'Editar',
                          onClick: () => {
                            navigateTo(`/ticket/edit/${item.id}`)
                          }
                        }
                      )
                      newActions.push(
                        {
                          className: 'btn',
                          icon: 'bi bi-trash',
                          tooltip: 'Borrar',
                          onClick: () => {
                            setSelectedItemId(item.id)
                          }
                        }
                      )
                    }

                    if (item.ticketStatus === 'en revisión') {
                      newActions.push(
                        {
                          className: 'btn',
                          icon: 'bi bi-eye',
                          tooltip: 'Revisar',
                          onClick: () => {
                            navigateTo(`/ticket/edit/${item.id}`)
                          }
                        }
                      )
                      newActions.push(
                        {
                          className: 'btn',
                          icon: 'bi bi-trash',
                          tooltip: 'Borrar',
                          onClick: () => {
                            setSelectedItemId(item.id)
                          }
                        }
                      )
                    }

                    return {
                      ticketTitle: item.ticketTitle,
                      //status must be first letter uppercase
                      ticketStatus: item.ticketStatus.charAt(0).toUpperCase() + item.ticketStatus.slice(1),
                      user_id:
                        item.user_id ? item.user.userFullName : {
                          text: 'Sin asignar',
                          className: 'align-middle text-danger'
                        },
                      actions: newActions,
                    }
                  })
                ]
              }
            />
          }
        </>
      }
      <ModalComponent
        id='deleteModal'
        title={deleteModalTitle}
        show={showDeleteModal}
        setShow={setShowDeleteModal}
      >
        <p>¿Está seguro que desea borrar este ticket?</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Cancelar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => {
              handleDataDelete(selectedItemId)
              setShowDeleteModal(false)
              setSelectedItemId(null)
            }}
          >
            Borrar
          </button>
        </div>
      </ModalComponent>
      <ModalComponent
        id='errorModal'
        title={errorModalTitle}
        show={showErrorModal}
        setShow={setShowErrorModal}
        headerClass='bg-danger text-white'
        modalSize='modal-lg'
      >
        <p>{errorMessage}</p>
        <div className='d-flex justify-content-between mt-4'>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={() => {
              setShowErrorModal(false)
              setSelectedItemId(null)
            }}
          >
            Ok
          </button>
        </div>
      </ModalComponent>
    </>
  )
}
